import React, { FC } from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { PaginationOptions } from '../../utils/types';

type Props = {
  currentPage?: number;
  resultsPerPage?: number;
  totalResults?: number;
  handleNext: VoidFunction;
  handlePrev: VoidFunction;
  paginationOptions?: PaginationOptions;
};

const Pagination: FC<Props> = ({
  currentPage,
  resultsPerPage,
  totalResults,
  handleNext,
  handlePrev,
  paginationOptions,
}) => {
  if (
    currentPage === undefined ||
    resultsPerPage === undefined ||
    totalResults === undefined
  ) {
    return <div>Loading..</div>;
  }

  const getStartRange = () => {
    if (
      currentPage !== undefined &&
      resultsPerPage !== undefined &&
      totalResults !== undefined
    ) {
      return currentPage * resultsPerPage + 1;
    } else return 0;
  };

  const getEndRange = (): any => {
    if (
      currentPage !== undefined &&
      resultsPerPage !== undefined &&
      totalResults !== undefined
    ) {
      if (getStartRange() + resultsPerPage - 1 < totalResults) {
        return getStartRange() + resultsPerPage - 1;
      } else return totalResults;
    }
  };

  const getTotalResults = () => {
    if (totalResults !== undefined) {
      return totalResults;
    } else return 0;
  };

  return (
    <div className="flex flex-row items-center">
      <div className="w-5/6">
        <span className="text-sm text-gray-700 dark:text-gray-400">
          {totalResults > resultsPerPage ? (
            <>
              <span>
                {' '}
                {paginationOptions
                  ? paginationOptions.leadingWord
                  : 'Showing'}{' '}
              </span>
              <span className="font-semibold text-gray-900 dark:text-white">
                {getStartRange()}
              </span>
              <span> to </span>
              <span className="font-semibold text-gray-900 dark:text-white">
                {getEndRange()}
              </span>
              <span> of </span>
            </>
          ) : (
            ''
          )}
          <span className="font-semibold text-gray-900 dark:text-white">
            {getTotalResults()}
          </span>

          <span>
            {' '}
            {paginationOptions && paginationOptions.itemName
              ? paginationOptions.itemName
              : 'Entries'}{' '}
          </span>
        </span>
      </div>
      <div className="inline-flex m-2 xs:mt-0 justify-end">
        {totalResults > resultsPerPage ? (
          <>
            <button
              onClick={handlePrev}
              disabled={currentPage === 0 ? true : false}
              className={`"py-2 px-4 text-sm font-medium text-white  rounded-l  dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                currentPage === 0 ? 'bg-gray-500' : 'bg-confirmed-secondary'
              }`}
            >
              <BsChevronLeft />
            </button>
            <button
              onClick={handleNext}
              disabled={getEndRange() === totalResults ? true : false}
              className={`py-2 px-4 text-sm font-medium text-white rounded-r border-0 border-l border-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                getEndRange() === totalResults
                  ? 'bg-gray-500'
                  : 'bg-confirmed-secondary'
              }`}
            >
              <BsChevronRight />
            </button>
          </>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default Pagination;
